import { render } from "./Wrapper.vue?vue&type=template&id=3ca3200e&scoped=true"
const script = {}

import "./Wrapper.vue?vue&type=style&index=0&id=3ca3200e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ca3200e"]])

export default __exports__